import React from 'react'
import classNames from 'classnames';

import { FONT_SIZES } from '../../../constants/font.constants';

export const ErrorLabel = ({ children, className = '', size = FONT_SIZES.XL }) => (
  <h4 className={classNames(`text-${size} text-gray-500`, className)}>{ children }</h4>
)

export default ErrorLabel;
